import Header from "@/components/Header";
import Footer from "@/components/Footer";

const SECTIONS = [
  ["What we collect",
    "Two kinds of information. First, advertised rental screening criteria from public listings — things like rent, minimum credit score, income requirement, reserves, application fee, and cosigner policy. Second, voluntary experiences shared by renters, landlords, property managers, and housing professionals. Contact details are only collected when you choose to provide them."],
  ["What we publish",
    "Only aggregated, anonymized statistics — medians, percentages, counts, and county-level comparisons. Individual listings and individual stories are never published. We do not name any renter, landlord, agent, or brokerage."],
  ["What we never do",
    "We do not sell your data. We do not share identifying information with third parties for marketing. We do not publish anything that identifies a specific landlord, tenant, or property. We do not create rankings, ratings, or 'worst of' lists."],
  ["How your contact information is used",
    "If you provide an email, we use it only to send a confirmation and, if you opt in, occasional research updates. If you grant explicit permission to be contacted about your story, a researcher may reach out. You can ask us to remove your information at any time."],
  ["How your story is protected",
    "Experiences are stored privately and reviewed by our research team. They inform aggregate findings and, where relevant, anonymized thematic summaries — never as a published individual account, and never with identifying details, unless you give explicit written permission."],
  ["Your control and requests",
    "You may request access to, correction of, or deletion of the information you submitted. Reach us at ray@proptekinc.com and we will respond promptly."],
];

export default function HowWeUseDataPage() {
  return (
    <div className="min-h-screen bg-white font-body text-ink">
      <Header />

      <section className="mx-auto max-w-7xl px-6 pb-12 pt-20 md:px-12 md:pt-28">
        <div className="text-xs uppercase tracking-[0.2em] text-calblue">How We Use Your Data</div>
        <h1 className="mt-4 max-w-3xl font-serif text-5xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
          Your information, handled with care.
        </h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-700">
          Trust is the foundation of independent research. This page explains, in plain language,
          exactly what we collect, how we use it, and the strict limits we place on ourselves — so
          you can participate with confidence.
        </p>
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-32 md:px-12">
        <div className="space-y-px bg-slate-200">
          {SECTIONS.map(([title, body], i) => (
            <div key={title} data-testid={`datause-${i + 1}`} className="bg-white py-8">
              <div className="flex gap-6">
                <span className="font-mono text-sm text-calblue">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h2 className="font-serif text-2xl font-medium leading-snug text-ink">{title}</h2>
                  <p className="mt-3 leading-relaxed text-slate-600">{body}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 border-l-2 border-navy pl-6">
          <p className="max-w-2xl font-serif text-2xl font-normal leading-snug text-ink">
            We collect only what research requires, publish only what is aggregated and anonymous,
            and never sell your data or name an individual.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
